import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import MainNavigationInfo from "components/mainNavInfo";
import {
	agentPermissionSet,
	getFullName,
	hasPermissions,
	merchantPermissionSet,
	uwDecisionPermissionSet,
	viewAppPermissionSet,
} from "helpers";
import { getAppStatuses } from "mappers";
import { dropdownValuesActions, merchantGeneralActions } from "store";

import Mid from "./mid";

type MerchantNavigationInfoProps = {
	merchantId: string;
};

const MerchantNavigationInfo = ({
	merchantId,
}: MerchantNavigationInfoProps) => {
	const dispatch = useDispatch();
	const generalData = useSelector(
		(state: any) => state.merchantGeneral.generalData,
	);

	useEffect(() => {
		(async function () {
			if (!merchantId) return null;

			const res: any = await dispatch(
				merchantGeneralActions.getMerchant(merchantId),
			);

			if (res.timeZoneName !== null) {
				dispatch(dropdownValuesActions.getTimeZone(res.timeZoneName));
			}
		})();
	}, [dispatch, merchantId]);

	const navInfoItems = useMemo(
		() => [
			{
				label: "App ID",
				data: generalData?.application?.number,
				path:
					generalData?.applicationId &&
					hasPermissions(viewAppPermissionSet)
						? `/applications/${generalData?.applicationId}/get-started`
						: "",
			},
			{
				label: "MID",
				data: <Mid merchant={generalData} />,
				path:
					generalData?.id &&
					hasPermissions([
						...merchantPermissionSet,
						...uwDecisionPermissionSet,
					])
						? `/merchant/list/info/${generalData?.id}/general`
						: "",
			},
			{
				label: "Business Name",
				data: generalData?.dbaName,
			},
			{
				label: "Application Status",
				data: getAppStatuses(
					generalData?.application?.application_status,
				),
			},
			{
				label: "Merchant Status",
				data:
					typeof generalData?.merchantStatus?.name === "string"
						? generalData?.merchantStatus?.name
						: getAppStatuses(generalData?.merchantStatus?.name),
			},
			{
				label: "Agent Office",
				data: generalData?.agent?.company?.name,
				path:
					generalData?.agent?.company?.id &&
					hasPermissions(agentPermissionSet)
						? `/system-setup/agent-office-setup/edit-agent-office/${generalData?.agent?.company?.id}/general-info`
						: "",
			},
			{
				label: "Agent Name",
				data: generalData?.agent && getFullName(generalData?.agent),
				path:
					generalData?.agent?.id && hasPermissions(agentPermissionSet)
						? `/system-setup/agent-setup/edit-agent/${generalData?.agent?.id}/general-info`
						: "",
			},
		],
		[generalData],
	);

	return (
		<MainNavigationInfo
			content={navInfoItems}
			title="Merchant Information"
			loading={false}
		/>
	);
};

export default MerchantNavigationInfo;
